import { useQuery } from '@tanstack/react-query';
import api from '@/lib/api';
import { Deployment } from '@/types/deployment';

async function fetchDeployments(projectId: string): Promise<Deployment[]> {
  const response = await api.get<{ data: Deployment[] }>(`/projects/${projectId}/deployments`);
  return response.data.data || [];
}

export function useDeployments(projectId: string | undefined) {
  return useQuery({
    queryKey: ['deployments', projectId],
    queryFn: () => fetchDeployments(projectId!),
    enabled: !!projectId,
  });
}
